import {
  AUTH_REQUEST, AUTH_LOGOUT, AUTH_SUCCESS, AUTH_FAILURE,
} from '../constants/auth.constants';

export const loginAction = (login, password, dominio) => ({
  type: AUTH_REQUEST,
  payload: { login, password, dominio },
});

export const authSuccessAction = (token, user, permisos, configuracion) => ({
  type: AUTH_SUCCESS,
  payload: {
    token, user, permisos, configuracion,
  },
});

export const authFailureAction = error => ({
  type: AUTH_FAILURE,
  payload: error,
});

export const logoutAction = () => ({
  type: AUTH_LOGOUT,
});
